(function (app) {

    app.run([
        "$transitions", "$window", function ($transitions, $window) {
            $transitions.onSuccess({},
                function (trans) {
                    var to = trans.to();
                    var title = "", obj;

                    if (to.data && to.data.pageTitle) {
                        title = to.data.pageTitle + " | ";
                    }

                    if (to.name.startsWith("Home.Settings.Agency.User.")) {
                        obj = trans.injector().get("user");
                        title += obj.FirstName + " " + obj.LastName + " | ";
                    }
                    else if (to.name.startsWith("Home.Calendar")) {
                        title += "Calendar | ";
                    }
                    else if (to.name.startsWith("Home.Client")) {
                        if (to.name.startsWith("Home.Client.Cases.Case")) {
                            obj = trans.injector().get("clientCase");
                            title += obj.Name + " | ";
                        }
                        
                        obj = trans.injector().get("client");
                        title += obj.Person.FirstName + " " + obj.Person.LastName + " | ";
                    }
                    else if (to.name.startsWith("Home.Marketing.Pipelines.Pipeline")) {
                        obj = trans.injector().get("pipeline");
                        title += obj.Name + " | ";
                    }
                    else if (to.name.startsWith("Home.Reports") && to.name !== "Home.Reports.List") {
                        obj = trans.injector().get("report");

                        if (obj && obj.Name) {
                            title += obj.Name + " | ";
                        }

                        if (to.name === "Home.Reports.Results") {
                            title += "Report Results | ";
                        }
                        else if (to.name === "Home.Reports.New" || to.name === "Home.Reports.Edit") {
                            title += "Edit Report | ";
                        }

                    }

                    title += "Force CRM";

                    $window.document.title = title;
                });
        }
    ]);

})(window.app); //jshint ignore:line